import {useContext, useEffect, useLayoutEffect, useState} from "react";
import DeviceContext from "../store/device-context";
import {isAppstore} from "../App";
import Header from "../moderator/header/Header";

import Footer from "../components/footer/Footer";
import MobilePage from "./main/MobilePage";
import DesktopPage from "./main/DesktopPage";
import AuthContext from "../store/auth-context";
import Loader from "../components/loader/Loader";
import ModalIsWorking from "../moderator/main/order/ModalIsWorking";
import AdModeratorContext from "../store/ad-moderator-context";

const AdModeratorLayout = () => {
    const [isWorking, setIsWorking] = useState(null);
    const acount = useContext(AuthContext)
    const ctx = useContext(AdModeratorContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

    useLayoutEffect(() => {
        if (ctx.workingHours === 404) {
            if (acount.userData?.workingHoursDay.success) {
                setIsWorking(true);
            } else {
                setIsWorking(false);
            }
        } else if (ctx.workingHours != null) {
            setIsWorking(ctx.workingHours);
        } else {
            setIsWorking(null);
        }
    }, [ctx.workingHours, acount.userData]);

    useEffect(() => {
        let timeout;

        const resetTimeout = () => {
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(() => {
                window.location.reload();
            }, 1200000);
        };

        const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];

        events.forEach((event) => window.addEventListener(event, resetTimeout));

        resetTimeout();

        return () => {
            clearTimeout(timeout);
            events.forEach((event) => window.removeEventListener(event, resetTimeout));
        };
    }, []);

    console.log(isWorking)

  const device = useContext(DeviceContext);
    localStorage.setItem('firstVisit', '1')
  return(
      <div className={isAppstore ? "copyBan" : undefined}>
        <Header />

        <main className="main">
            {
                isWorking === null ? (
                    <Loader />
                ) : isWorking ? (
                    device.isMobile ? <MobilePage /> : <DesktopPage />
                ) : (
                    <ModalIsWorking />
                )
            }
        </main>

        <Footer />
      </div>
  )
}

export default AdModeratorLayout;